import whatsappLink from './whatsapp-link'

const DIRECTIVES = [
	whatsappLink
]

export default function installDirectives(App) {
	for (const item of DIRECTIVES) {
		App.directive(item.name, item.directive)
	}
}
